import React from "react";
import { ShoppingBag, Check, MapPin } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import Reveal from "./Reveal";

const IMG = "https://images.unsplash.com/photo-1754391853207-03bbb7e757dc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const OnSiteBoutique = () => {
  const { t } = useI18n();
  return (
    <section className="py-20 lg:py-28" data-testid="onsite-boutique">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal className="relative">
          <div className="rounded-3xl overflow-hidden aspect-[4/3] shadow-[0_20px_60px_rgba(44,48,48,0.12)]">
            <img src={IMG} alt={t("onsite.title")} loading="lazy" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-5 -right-3 sm:right-6 rounded-2xl bg-brand text-white px-5 py-3 flex items-center gap-2.5 shadow-lg">
            <ShoppingBag size={20} strokeWidth={1.75} />
            <span className="font-heading text-lg">{t("onsite.tag")}</span>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <p className="text-brand font-accent text-2xl italic mb-3">{t("onsite.tag")}</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-ink-900 mb-5">{t("onsite.title")}</h2>
          <p className="text-ink-600 font-body leading-relaxed mb-6">{t("onsite.text")}</p>
          <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3 mb-6">
            {t("onsite.items").map((it) => (
              <li key={it} className="flex items-center gap-2.5 text-sm text-ink-700 font-body">
                <span className="w-6 h-6 rounded-full bg-brand-50 flex items-center justify-center shrink-0">
                  <Check size={14} className="text-brand" />
                </span>
                {it}
              </li>
            ))}
          </ul>
          <p className="inline-flex items-center gap-2 rounded-full bg-beige px-4 py-2 text-sm text-ink-600">
            <MapPin size={15} className="text-brand" /> {t("onsite.note")}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
